/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { INearIntentsToken } from 'services/nearIntents'
import { INearIntentsState } from './types'

const initialState: INearIntentsState = {
	tokens: [],
	isLoadingTokens: false,
	tokensError: null,
}

const nearIntentsSlice = createSlice({
	name: 'nearIntents',
	initialState,
	reducers: {
		fetchTokensRequest: (state) => {
			state.isLoadingTokens = true
			state.tokensError = null
		},
		fetchTokensSuccess: (state, { payload }: PayloadAction<INearIntentsToken[]>) => {
			state.isLoadingTokens = false
			state.tokens = payload
		},
		fetchTokensFailure: (state, { payload }: PayloadAction<string>) => {
			state.isLoadingTokens = false
			state.tokensError = payload
		},
		resetNearIntents: () => initialState,
	},
})

export const {
	fetchTokensRequest,
	fetchTokensSuccess,
	fetchTokensFailure,
	resetNearIntents,
} = nearIntentsSlice.actions

export const { reducer } = nearIntentsSlice
